export const ZYE_NAME='saaszhengyesoho'